<template>
<div class="container text-center text-muted p-3">
  <prismic-link :field="fields.link" v-if="fields.link">
    <prismic-rich-text :field="fields.copyright"/>
  </prismic-link>
</div>
</template>

<script>
export default {
  name: 'footer-component',
  data () {
    return {
      fields: {
        copyright: null,
        link: null
      }
    }
  },
  methods: {
    fetchPrismicContent () {
      this.$prismic.client.getSingle('component-footer')
        .then((document) => {
          this.fields.copyright = document.data.copyright
          this.fields.link = document.data.link
        })
    }
  },
  created () {
    this.fetchPrismicContent()
  }
}
</script>

<style scoped>

  .logo {
      width: 250px;
      margin-top: -100px;
  }

  a {
    color: #767676;
    text-decoration: none;
  }

  a:hover {
    color: #a0a0a0;
  }
</style>
